import {openPrescribedNameDrawer} from '@/modules/products/trade-names/components/prescribed-name-drawer/util'
import {PrescribedName} from '@cypro/engine/schema'
import {ResourceTag, ResourceTagProps} from '@cypro/ui/components/ui/tags/resource-tag'

export interface PrescribedNameTagProps extends Omit<ResourceTagProps, 'onClick'> {
  prescribedName?: PrescribedName | null
}

export function PrescribedNameTag({prescribedName, ...props}: PrescribedNameTagProps) {
  return (
    <ResourceTag
      {...props}
      onClick={() => {
        if (prescribedName) openPrescribedNameDrawer(prescribedName)
      }}
      data-e2e="prescribed-name-tag"
      data-prescribed-name-id={prescribedName?.id}
    >
      {prescribedName?.name || '-'}
    </ResourceTag>
  )
}
